// Canonical service-category icon key list (value = what's stored on ServiceCategory.icon).
// Keep in sync with mobile/PatientApp/src/screens/home/homeListingShared.ts (getCategoryIcon),
// mobile/ProfessionalApp/src/utils/categoryIcons.ts, and web-app/src/utils/categoryIcons.tsx —
// these can't share code across separate React/React Native/Laravel projects, so the key set is
// mirrored by hand. This list is the reference the other three should stay aligned with.
export interface CategoryIconOption {
  value: string;
  emoji: string;
  label: string;
}

export const CATEGORY_ICON_OPTIONS: CategoryIconOption[] = [
  { value: 'stethoscope', emoji: '🩺', label: 'Stethoscope' },
  { value: 'heart', emoji: '❤️', label: 'Heart' },
  { value: 'brain', emoji: '🧠', label: 'Brain' },
  { value: 'pill', emoji: '💊', label: 'Pill' },
  { value: 'syringe', emoji: '💉', label: 'Syringe' },
  { value: 'thermometer', emoji: '🌡️', label: 'Thermometer' },
  { value: 'bandage', emoji: '🩹', label: 'Bandage' },
  { value: 'medical-bag', emoji: '🏥', label: 'Medical Bag' },
  { value: 'hospital', emoji: '🏥', label: 'Hospital' },
  { value: 'doctor', emoji: '👨‍⚕️', label: 'Doctor' },
  { value: 'nurse', emoji: '👩‍⚕️', label: 'Nurse' },
  { value: 'pharmacy', emoji: '💊', label: 'Pharmacy' },
  { value: 'ambulance', emoji: '🚑', label: 'Ambulance' },
  { value: 'x-ray', emoji: '📷', label: 'X-Ray' },
  { value: 'dental', emoji: '🦷', label: 'Dental' },
  { value: 'eye', emoji: '👁️', label: 'Eye' },
  { value: 'ear', emoji: '👂', label: 'Ear' },
  { value: 'general', emoji: '🏥', label: 'General' },
  { value: 'medicine', emoji: '💊', label: 'Medicine' },
  { value: 'surgery', emoji: '⚕️', label: 'Surgery' },
  { value: 'cardiology', emoji: '❤️', label: 'Cardiology' },
  { value: 'neurology', emoji: '🧠', label: 'Neurology' },
  { value: 'orthopedic', emoji: '🦴', label: 'Orthopedic' },
  { value: 'pediatric', emoji: '👶', label: 'Pediatric' },
  { value: 'gynecology', emoji: '👩', label: 'Gynecology' },
  { value: 'dermatology', emoji: '✨', label: 'Dermatology' },
  { value: 'psychiatry', emoji: '🧠', label: 'Psychiatry' },
  { value: 'physiotherapy', emoji: '🏃', label: 'Physiotherapy' },
  { value: 'elderly', emoji: '👴', label: 'Elderly' },
  { value: 'companionship', emoji: '🤝', label: 'Companionship' },
  { value: 'post-operative', emoji: '🩹', label: 'Post-Operative' },
  { value: 'home-care', emoji: '🏠', label: 'Home Care' },
  { value: 'dumbbell', emoji: '🏋️', label: 'Dumbbell' },
  { value: 'comfort', emoji: '🛌', label: 'Comfort' },
  { value: 'oxygen', emoji: '💨', label: 'Oxygen' },
  { value: 'home', emoji: '🏡', label: 'Home' },
  { value: 'video-call', emoji: '📹', label: 'Video Call' },
];

export const getCategoryIconEmoji = (icon?: string): string => {
  const normalized = icon?.toLowerCase().trim();
  return CATEGORY_ICON_OPTIONS.find((option) => option.value === normalized)?.emoji || '🏥';
};
